import { render, staticRenderFns } from "./_bulk_move_items_modal.vue?vue&type=template&id=a9907710&scoped=true&"
import script from "./_bulk_move_items_modal.vue?vue&type=script&lang=js&"
export * from "./_bulk_move_items_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9907710",
  null
  
)

export default component.exports